import styled from "styled-components";
import { NotResultFound } from "@assets";

export const EmptyContainer = styled.div`
  height: ${props => (`calc(100vh - ${props.minHeight}px)`)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

export const EmptyImage = styled.img.attrs({
  alt: "img",
  src: NotResultFound,
})`
  object-fit: contain;
`;

export const EmptyText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.textColor};
  padding-top: 8px;
`;
